import { pleaseEnterTheMessage, requiredMessage } from "../utils/common";
var bsb = function bsb(value) {
  return !/^\d{6}$/.test(value);
};
var VARIANTS = {
  ARHI: "BSB number"
};
var VARIANT_REQUIRED_FUNCTION = {
  ARHI: requiredMessage,
  IAP: pleaseEnterTheMessage
};
var validBsb = function validBsb(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fieldName = arguments.length > 2 ? arguments[2] : undefined;
  var error;
  var field = fieldName || VARIANTS[funnel] || VARIANTS.ARHI;
  if (!value) {
    var requiredFunction = VARIANT_REQUIRED_FUNCTION[funnel] || VARIANT_REQUIRED_FUNCTION.ARHI;
    error = requiredFunction(field);
  } else if (bsb(value)) {
    error = "Your ".concat(field, " must have 6 digits. Please enter your BSB again.");
  }
  return error;
};
export default validBsb;